import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

export interface PageMetaConfig {
  title: string;
  description?: string;
}

export const PageMeta = (meta: PageMetaConfig) => {
  const { t } = useTranslation();
  const resolvedTitle = t(meta.title, { defaultValue: meta.title });
  const resolvedDescription = meta.description
    ? t(meta.description, { defaultValue: meta.description })
    : undefined;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [resolvedTitle]);

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      {resolvedDescription ? <meta name="description" content={resolvedDescription} /> : null}
    </Helmet>
  );
};

export const usePageMeta = (meta: PageMetaConfig) => {
  return <PageMeta {...meta} />;
};
